import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import WhyChooseUs from "@/components/WhyChooseUs";
import BookingForm from "@/components/BookingForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-white" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Projects />
        <WhyChooseUs />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
